import React, { useEffect, useState } from "react";
import "../css/dashboard.scss";
import Header from "../components/header/Header";
import { getPartnerSeries, getSeriesSeasons } from "../services/partner";
import { Link } from "react-router-dom";

// Series dashboard — backed by GET /api/partner/stats/series.
// Seasons are not included in the per-series stats payload, so for each row
// we fan out a second request to GET /api/season/getall/:id (the public
// legacy season list) to render the "go to episodes" buttons. Small list,
// small N+1 — fine for the portal.
const SerieDashboard = () => {
  const [rows, setRows] = useState([]);
  const [seasonsByContent, setSeasonsByContent] = useState({});

  useEffect(() => {
    getPartnerSeries().then((res) => {
      const items = res.data.data || [];
      setRows(items);
      items.forEach((row) => {
        getSeriesSeasons(row.content_id)
          .then((sres) => {
            // Public season endpoint returns a raw array.
            const seasons = Array.isArray(sres.data) ? sres.data : [];
            setSeasonsByContent((prev) => ({ ...prev, [row.content_id]: seasons }));
          })
          .catch(() => {
            setSeasonsByContent((prev) => ({ ...prev, [row.content_id]: [] }));
          });
      });
    });
  }, []);

  return (
    <div className="box">
      <Header />
      <div className="filter"></div>
      <div className="all-center">
        <div className="box-table">
          <table>
            <tbody>
              <tr className="text-center">
                <th>IMAGE</th>
                <th>NAME</th>
                <th>PRICE FOR VIEW</th>
                <th>VIEWS COUNT</th>
                <th>PARTNER'S PAYMENT</th>
                <th>EPISODES</th>
              </tr>

              {rows.map((row) => {
                const seasons = seasonsByContent[row.content_id] || [];
                return (
                  <tr key={row.content_id}>
                    <td>
                      <img
                        width={60}
                        src={"https://media.metaflix.az/" + row.main_picture}
                        alt=""
                      />
                    </td>
                    <td>{row.name}</td>
                    <td>{row.cash} AZN </td>
                    <td>{row.hit}</td>
                    <td>{row.part} AZN</td>
                    <td
                      className="d-flex flex-column gap-2 justify-content-center align-items-center"
                      style={{ minHeight: 100 }}
                    >
                      {seasons.map((season) => (
                        <Link to={`/episodeDashboard/${season._id || season.id}`} key={season._id || season.id}>
                          <button>SEASON {String(season.name)}</button>
                        </Link>
                      ))}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SerieDashboard;
